import { memo, Suspense, useEffect } from 'react';
import { Flex, Layout } from 'antd';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainLayoutNotif from './MainLayoutNotif';
import MainLayoutSideMenu from './MainLayoutSideMenu';
import useWindowSize from '../../hooks/useWindowSize';
import './MainLayout.scss';

const { Content } = Layout;

const MainLayout = ({ children, fullPage }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const { isMobile } = useWindowSize();

  const langRedux = useSelector((state) => {
    return state.lang;
  });

  useEffect(() => {
    if (lang !== langRedux) {
      i18n.changeLanguage(lang);
    }
  }, [lang, langRedux, i18n]);

  return (
    <Layout className="main_layout" hasSider={!isMobile}>
      <MainLayoutSideMenu />
      <Flex
        vertical
        style={{
          flex: 1,
          minHeight: 0,
          overflow: isMobile ? 'auto' : 'hidden',
        }}
      >
        <MainLayoutNotif />
        <Content
          className={`main_content
              main_content_wrapper
              ${fullPage || isMobile ? 'full_width' : 'width_700'}
              `}
          style={{
            flex: 1,
            minHeight: 0,
            maxWidth: 2056,
          }}
        >
          <Suspense fallback={null}>{children}</Suspense>
        </Content>
      </Flex>
    </Layout>
  );
};

export default memo(MainLayout);
